$(document).ready(function($) {
    gsap.registerPlugin(ScrollTrigger, SplitText, ScrollSmoother);
    ScrollTrigger.config({ ignoreMobileResize: true });
    //ScrollTrigger.normalizeScroll(true);

    var $textAnimate  = $("p.text-animate"),
        $projectImage = $(".project-image-animate"),
        $footer       = $("footer"),
        $spacer       = $(".spacer"),
        $conceptVideo = $("#concept-video"),
        $featuredIn   = $("#featured-in"),
        $smoothContent  = $("#smooth-content"),
        $scrolling      = $("#scrolling"),
        $slogan         = $("#slogan"),
        $preloadAnimate = $(".preload-animate-container"),
        isAnimateEnd    = false,
        masks,
        split = $textAnimate.length > 0 ? new SplitText($textAnimate, {
            type: "lines",
            tag: "div",
        }) : null,
        tlFooter,
        tlmenu;

    function smootherPage() {
        globalSmoother = ScrollSmoother.create({
            smooth: 1.5,
            smoothTouch: 0.1, 
            effects: true,
            ignoreMobileResize: true,
            //preventDefault: false,
            normalizeScroll: (Foundation.MediaQuery.is("small")) ? true : {
                allowNestedScroll: true,
            }
        });
    }

    function getVariable() {
        $('body').css('--footer-height', ($("footer").outerHeight() - 5) +'px');
    }

    function animateText() {
        masks = [];
        if (split) {
            split.lines.forEach((target) => {
                let mask = document.createElement("span");

                mask.className = "mask";
                target.append(mask);
                masks.push(mask);

                gsap.to(mask, {
                    scaleX: 0,
                    transformOrigin: "right center",
                    ease: "none",
                    scrollTrigger: {
                        trigger: target,
                        scrub: true,
                        start: "top 70%",
                        end: "bottom 70%"
                    }
                });
            });
        }
    }

    function animateProject() {
        if (($projectImage.length > 0) && (Foundation.MediaQuery.atLeast('medium'))) {
            gsap.from($projectImage, {
                y: 124,
                scrollTrigger: {
                    trigger: $projectImage,
                    scrub: true,
                    start: "top bottom",
                    end: "top+=300px 60%",
                    //markers: true
                }
            })
        }
    }

    function revealFooter() {
        tlFooter = gsap.timeline({
            scrollTrigger: {
                id: "footer-st",
                trigger: $spacer,
                scrub: true,
                start: "top bottom",
                end: "bottom bottom",
                //markers: true,
            }
        })

        tlFooter
        //.fromTo($('.footer-wrapper'), { opacity: 0.1, }, { opacity: 1 })
        .set($spacer, { display: "none" }, '-=1');
    }

    function footerResize() {
        gsap.set($spacer, {display: "block"});
        getVariable();
        ScrollTrigger.refresh();
        ScrollTrigger.getById("footer-st").kill();
        revealFooter();
    }

    function animateSectionBgChange() {
        if ($conceptVideo.length > 0) {

            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: $conceptVideo.find('video'),
                    scrub: true,
                    start: "top bottom",
                    end: "+="+($window.height()*1.5)+"px bottom",
                    //markers: true,
                }
            });

            tl.fromTo([$featuredIn, $header], { filter: "invert(0)" }, { filter: "invert(1)" }, "-=1")
                .fromTo($smoothContent, {
                    backgroundColor: "#fff"
                }, {
                    backgroundColor: "#000"
                }).to($smoothContent, {
                    backgroundColor: "#fff"
                }, "+=1").to([$featuredIn, $header], {
                    filter: "invert(0)"
                }, "-=0.5");
        }
    }

    function animateSticky() {
        if (($scrolling.length > 0) && Foundation.MediaQuery.atLeast('medium')) {
            let $stickyImage      = $scrolling.find('.sticky-image');
            let $scrollingContent = $scrolling.find('.scrolling-content');

            if ($stickyImage.length > 0) {
                let tl = gsap.timeline({
                    scrollTrigger: {
                        id: "sticky-scrolling",
                        trigger: $stickyImage,
                        scrub: true,
                        pin: true,
                        pinSpacing: false,
                        start: "top "+$header.height()/4+"px",
                        end: "+="+($scrollingContent.height())+"px bottom",
                        //markers: true,
                    }
                });
            }
        }
    }

    function animateSlogan() {
        if ($slogan.length > 0) {

            let tl = gsap.timeline({
                scrollTrigger: {
                    //id: "sticky-scrolling",
                    trigger: $slogan,
                    scrub: 4,
                    start: "top center",
                    end: "+=110% center",
                    //markers: true,
                    //ease: "power3.out",
                },
            });

            let defaultW = "60%";
            let $shortLine = $slogan.find('.line.short');
            let $sideLine  = $slogan.find('.line:not(.short)');
            tl.set($sideLine, { width : "20%" });
            tl.fromTo($shortLine, {
                width: defaultW,
            }, {
                width: "8%",
            }).to($sideLine, {
                width: "50%"
            }, "-=0.5").to($shortLine, {
                width: defaultW
            }, "+=1").to($sideLine, {
                width: "20%"
            }, "-=0.5");
        }
    }

    function animatePreload() {
        if ($preloadAnimate.length > 0) {
            globalSmoother.scrollTo(0, false);
            globalSmoother.paused(true);
            $preloadAnimate.removeClass('onload');

            let $imgCont   = $preloadAnimate.find('.img-container');
                $imgPin    = $preloadAnimate.find('.img-pinning'),
                $centerImg = $preloadAnimate.find('.center-img'),
                $img       = $preloadAnimate.find('.img:not(.estica-logo)'),
                $img1      = $preloadAnimate.find('.img-1'),
                $img2      = $preloadAnimate.find('.img-2'),
                $img3      = $preloadAnimate.find('.img-3'),
                $img4      = $preloadAnimate.find('.img-4'),
                $esticaLogo = $preloadAnimate.find('.estica-logo'),
                $imgWrapper = $preloadAnimate.find('.img-wrapper'),
                $esticaLogoWrapper = $preloadAnimate.find('.estica-logo-wrapper'),
                topPos     = ($window.height() * 0.55) / 2,
                imgCenterH = $window.height() * 0.45,
                $screenAnimate = $preloadAnimate.find('.screen-animate'),
                $scrAnimateTmp = $preloadAnimate.find('.screen-animate.temp'),
                allowScroll    = true,
                scrollTimeout  = gsap.delayedCall(1, () => allowScroll = true).pause(),
                currentIndex   = 0,
                swipePanels    = gsap.utils.toArray(".preload-animate-container .screen-animate"),
                animating      = false;


            let defaultImgHeight = (imgCenterH * 0.55);
            let imgY             = 0;
            let imgY2            = 0;
            let centerImgWidth   = $window.width() / 1.6;
            let centerImgHeight  = $window.height() / 1.2;
            let isMobile         = false;

            gsap.set($img2, { xPercent: -45, yPercent: 25 });
            gsap.set($img3, { xPercent: 30, yPercent: -10 });
            gsap.set($img4, { xPercent: -10, yPercent: -30 });

            if ($(window).outerWidth() < 1024) {
                isMobile         = true;
                imgCenterH       = $window.height() * 0.3,
                defaultImgHeight = (imgCenterH * 0.6);
                imgY             = 40;
                imgY2            = -40;
                centerImgWidth   = $window.width() / 1.1;
                centerImgHeight  = $window.height() / 1.6;

                gsap.set($img2, { xPercent: -14, yPercent: -45 });
                gsap.set($img3, { xPercent: 30, yPercent: 60 });
                gsap.set($img4, { xPercent: 0, yPercent: -10 });
            }

            // initial
            $header.addClass('hide hide-logo');
            $body.css('--top-position', topPos+'px');
            $body.css('--img-height', imgCenterH+'px');
            gsap.set(swipePanels, { zIndex: i => swipePanels.length - i})
            gsap.set($img, { "height" : defaultImgHeight+"px", "width" : (defaultImgHeight * 1.15)+"px" });
            gsap.set($centerImg, { scale: 1, xPercent: -50, x: 0, left: "50%" });
            gsap.fromTo([$img, $esticaLogo, $centerImg], { opacity: 0 }, { opacity: 1, stagger: 0.2 });

            let intentObserver = ScrollTrigger.observe({
                type: "wheel,touch,pointer",
                onUp: (self) => {
                    if ((self.event.type == 'touchmove') || (self.event.type == 'touchend')) {
                        !animating && allowScroll && gotoPanel(currentIndex + 1, true)
                    }
                },
                onDown: (self) => {
                    if (!((self.event.type == 'touchmove') || (self.event.type == 'touchend'))) {
                        !animating && allowScroll && gotoPanel(currentIndex + 1, true)
                    }
                },
                tolerance: 10,
                preventDefault: true,
                onEnable(self) {
                    allowScroll = false;
                    scrollTimeout.restart(true);
                    let savedScroll = self.scrollY();
                    self._restoreScroll = () => self.scrollY(savedScroll);
                    document.addEventListener("scroll", self._restoreScroll, {passive: false});
                },
                onDisable: self => document.removeEventListener("scroll", self._restoreScroll)
            });
            intentObserver.disable();
            globalSmoother.paused(true);

            ScrollTrigger.create({
                id: "st-observer",
                trigger: ".preload-animate-container",
                pin: true,
                start: "top top",
                end: "+=200",
                onEnter: (self) => {
                    if (intentObserver.isEnabled) { return }
                    self.scroll(self.start + 1);
                    intentObserver.enable();
                },
                onEnterBack: (self) => {
                    if (intentObserver.isEnabled) { return }
                    self.scroll(self.end - 1);
                    intentObserver.enable();
                }
            });

            function gotoPanel(index, isScrollingDown) {
                if ((index === swipePanels.length && !isScrollingDown) || (index === -1 && !isScrollingDown) ||
                    (index >= swipePanels.length) ) {
                    return;
                }
                allowScroll = false;
                animating   = true;
                scrollTimeout.restart(true);

                let tlPanel = gsap.timeline({
                    onComplete: () => animating = false
                });

                let target = isScrollingDown ? swipePanels[currentIndex] : swipePanels[index];
                if (currentIndex == 0) {
                    tlPanel
                    .to($img2, {
                        xPercent: 0,
                        yPercent: imgY
                    })
                    .to($img3, {
                        xPercent: 0,
                        yPercent: imgY2
                    }, "-=0.5")
                    .to($img4, {
                        xPercent: 0,
                        yPercent: imgY2
                    }, "-=0.5")
                    .to($img1, {
                        xPercent: 0,
                        yPercent: imgY
                    }, "-=0.5")
                    .to($centerImg, {
                        scale: 1.2
                    }, "-=0.5")
                    .to($esticaLogo, {
                        width: "60%"
                    }, "-=0.5");
                }

                if (currentIndex == 1) {

                    tlPanel
                    .fromTo($centerImg.find('img'), {
                        scale: 1.25
                    },{
                        scale: 1
                    }, "-=0.5")
                    .to($centerImg, {
                        scale: 1,
                        width: centerImgWidth+"px",
                        height: centerImgHeight+"px",
                        top: ($window.height() - centerImgHeight) / 2+"px",
                    })
                    .to($esticaLogo, {
                        width: isMobile ? "58%" : "38.5%"
                    }, "-=0.5")
                    .to($img, {
                        width: isMobile ? 42 : 100,
                        height: isMobile ? 42 : 100,
                        backgroundColor: "#fff"
                    }, "-=0.5")
                    .to([$img1, $img3], {
                        left: isMobile ? "11%" : "25%"
                    }, isMobile ? "-=0.5" : "-=0.5")
                    .to([$img2, $img4], {
                        right: isMobile ? "11%" : "25%"
                    }, "-=0.5")
                    .to($img.children(), {
                        opacity: 0
                    }, "-=0.6")
                    .to([$img3, $img4], {
                        top: $window.height() - ((topPos * 0.6) + 100)  
                        //top: isMobile ? $window.height() * 0.64 : $window.height() * 0.77
                    }, "-=0.5")

                    if (isMobile) {
                        tlPanel.to([$img1, $img2], {
                            top: $esticaLogo.get(0).offsetTop - 42
                        }, "-=0.5")
                        .to([$img3, $img4], {
                            top: ($esticaLogo.get(0).offsetTop + $esticaLogo.height()),
                        }, "-=0.5");
                    }
                }

                if (currentIndex == 2) {
                    if (isMobile) {
                        tlPanel.to($esticaLogoWrapper, {
                            scale: "0.8",
                            top: "10%"
                        }); //, "-=0.5")
                    }
                    tlPanel.to($centerImg, {
                        top: 0,
                        scale: isMobile ? 1.01 : 1,
                        y: isMobile ? -100 : -200,
                        duration: 1.4,
                        width: $window.width()+"px",
                        height: $window.height() + (isMobile ? 100 : 200) +"px",
                    })
                    .to([$esticaLogoWrapper], {
                        opacity: 0,
                    }, "-=0.5");

                    setTimeout(() => {
                        isAnimateEnd = true;
                        intentObserver.kill();
                        globalSmoother.paused(false);
                        globalSmoother.scrollTop(0);

                        let obs = ScrollTrigger.getById("st-observer");
                        if (obs) {
                            getVariable();
                            obs.kill();
                            globalSmoother.refresh();
                        }
                        
                        gsap.fromTo( $centerImg.find('img'), {
                            y: 0
                        },{
                            y: isMobile ? 150 : 200,
                            ease: "none",
                            scrollTrigger: {
                                trigger: '.preload-animate-container',
                                scrub: true,
                                //markers: true,
                                start: "20% top",
                                end: "bottom+=100px top-=30%",
                            }
                        }) 

                        setTimeout(() => {
                            $header.removeClass('hide').addClass('headroom--not-top headroom--unpinned').removeClass('headroom--pinned').removeClass('hide-logo')
                            $body.addClass('logo-color-flipped');
                            $preloadAnimate.removeClass('bgcolor-dark-gray');
                        }, 400);

                        setTimeout(() => {
                            $header.removeClass('headroom--not-top headroom--unpinned').addClass('headroom--pinned headroom--top');
                        }, 900);
                    }, 900);
                }

                currentIndex = index;
            }
        }
    }

    function animateImgParallaxInside() {
        var $imgs = $('img.animate-parallax');
        if ($imgs.length > 0) {
            $imgs.each(function(){
                let height   = $(this).hasClass('img-full-height') ? $window.height() : $(this).outerHeight();
                let addonVal = height * 0.2;
                $(this).wrap('<div class="img-parallax-wrapper"></div>');
                $(this).css({
                    'height': height + addonVal,
                    'object-fit' : 'cover'
                });
                $(this).parent().css({
                    'height': height,
                    'overflow': 'hidden',
                });

                gsap.fromTo( $(this), {
                        y: -addonVal
                    },{
                        y: 0,
                        ease: "none",
                        scrollTrigger: {
                            trigger: $(this),
                            scrub: true,
                            //markers: true,
                            start: "top-=20px 60%",
                            end: "bottom top",
                        }
                    }
                )
            });
        }
    }

    $(window).on('resize', function(){
        animateTextResize();
        animateSectionBgChange();
        tlmenu.pause();

        //footerResize();
        setTimeout(() => {
            menuAnimate();
            //footerResize();

            let stSticky = ScrollTrigger.getById("sticky-scrolling");
            if (stSticky) {
                stSticky.kill();
            }

            animateSticky();
        }, 500);
    })

    function animateTextResize() {
        if (split) {
            ScrollTrigger.getAll().forEach((trigger, i) => {
                if (masks[i]) {
                    trigger.kill();
                    masks[i].remove();
                }
            });
            split.split();
            animateText();
        }
    }

    function animateCursor() {
        window.addEventListener("mousemove", e => {
            $(".cursor").css({
                'transform': `translate3d(${e.clientX}px, ${e.clientY}px, 0)`
            })
        });

        $(document).on('mouseover', 'a, .menu-toggle', function(){
            gsap.to(".cursor", { height: 32, width: 32, duration: 0.3 });
        }).on('mouseleave', 'a, .menu-toggle', function(){
            gsap.to(".cursor", { height: 12, width: 12, duration: 0.3 });
        })

        $(document).on('mouseover', '.thumbnail-hover', function(){
            gsap.to(".cursor", { height: 54, width: 111, duration: 0.3, backgroundColor: "#222222", mixBlendMode: "unset" });
            gsap.to(".cursor .text", { opacity: 1 });
        }).on('mouseleave', '.thumbnail-hover', function(){
            gsap.to(".cursor .text", { opacity: 0, duration: 0.2 }, "-=1");
            gsap.to(".cursor", { height: 12, width: 12, duration: 0.3, backgroundColor: "#fff", mixBlendMode: "difference" });
        })
    }

    function prepareNavCarousel(){
        let $navMenu = $("nav.nav-menu");
        gsap.set($navMenu, { height: "100%", top: "-100%"});    
           
        navHandler.adjustNavCarousel(true);
        navHandler.$navCarousel.flickity('select', 0, true, true);
        navHandler.$navCarousel.find('.carousel-cell').eq(0).addClass('is-active');
        navHandler.$navCarousel.flickity('playPlayer');

        let $mainMenu = $navMenu.find(".main-menu");
        let h = 0;
        $mainMenu.children().each(function(){
            h += $(this).height();
        });
        let pt = (($mainMenu.height() - h) / $mainMenu.children().length) / 2; 
        $mainMenu.children().css({
            'padding-top': pt+'px',
            'padding-bottom': pt+'px'
        });
    }

    function menuAnimate() {
        $('.menu-toggle').removeClass("disable");
        tlmenu = gsap.timeline({
            repeatRefresh: true,
            immediateRender: true,
            onStart: function(){
                globalSmoother.paused(true);
                $html.addClass('disable-scroll');
            },
            onComplete: function(){
                //prepareNavCarousel();
                $('.menu-toggle').removeClass('disable');
            },
            onReverseComplete: function() {
                $html.removeClass('disable-scroll');
                globalSmoother.paused(false);
                navHandler.$navCarousel.flickity('pausePlayer');
                $('.menu-toggle').removeClass('disable');
            }
        });

        let $navMenu = $("nav.nav-menu");

        prepareNavCarousel();
        setTimeout(() => {
            gsap.set($navMenu, { height: 0, top: 0});        
        }, 1000);
    
        tlmenu.fromTo($navMenu, { height: 0},{
            height: $(window).height(),
            duration: 1.2,
            ease: "power4.out",
            delay: 0.2
        })
        .fromTo($navMenu.find("hr"), { width: 0 }, { width: "100%", duration: 1.5, stagger: 0.2 }, "-=1")
        .fromTo([$navMenu.find(".menu-item a")], { yPercent: 150, opacity: 0 },{
            yPercent: 0,
            opacity: 1,
            stagger: 0.2
        }, "-=2")
        .fromTo([$navMenu.find(".featured-projects-carousel")], { opacity: 0 },{
            opacity: 1,
            stagger: 0.2
        }, "-=1.5")
        .fromTo([$navMenu.find(".menu-item .number .text")], { yPercent: 150, opacity: 0 },{
            yPercent: 0,
            opacity: 1,
            stagger: 0.2
        }, "-=2")
        .fromTo($navMenu.find(".link2 a"), { yPercent: 150 },{
            yPercent: 0,
            stagger: 0.2
        }, "-=1")
        .fromTo($navMenu.find(".menu-footer .footer-text"), { yPercent: 150 },{
            yPercent: 0,
            stagger: 0.2
        }, "-=1")
        .fromTo([$navMenu.find(".link-fade")], { opacity: 0 },{
            opacity: 1,
            stagger: 0.2
        }, "-=0.5")
        
        .pause();
        
    }

    $(document).on("click", ".menu-toggle", function() {
        tlmenu.invalidate();
        $('.menu-toggle').addClass("disable");
        $("nav.nav-menu").toggleClass('is-active');
        let isShow = ($("nav.nav-menu").hasClass('is-active'));
        if (isShow) {
            tlmenu.timeScale(1).play();
        } else {
            tlmenu.timeScale(-2).reverse();
        }
    });


    /// call all animate
    menuAnimate();
    animateCursor();
    smootherPage();
    animatePreload();
    getVariable();
    animateText();
    animateProject();
    //revealFooter();
    animateSectionBgChange();
    animateSticky();
    animateSlogan();
    animateImgParallaxInside();

})
